'use-strict';

import angular from 'angular';
import { FrontendSellerAPIAdRequest, PublishSellerAPIAdResponse } from '../../src/app/@shared-types/api/mobile-de';

import { ApiService } from '../../src/app/shared/services/api';

export class PlatformsAPIService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    'ngInject';

    this.apiService = apiService;
  }

  public postAd = (
    data: FrontendSellerAPIAdRequest,
  ): Promise<PublishSellerAPIAdResponse> => this.apiService.post<PublishSellerAPIAdResponse>('/api/mobile-api/seller/ads', data);

  public deleteAd = (
    vehicleId: string,
  ): Promise<void> => this.apiService.delete<void>(`/api/mobile-api/seller/ads/${vehicleId}`);
}

export default angular.module('services.platformsApiService', [])
  .service('platformsApiService', PlatformsAPIService)
  .name;
